import {themeV2, pxToEm, replacePXinStringWithEM} from '@insticator/insticator-ui';

export default {
  sentimentshowcase: {
    padding: '1em',
    marginBottom: pxToEm(20),
    '& .sentiment-title': {
      textAlign: 'center',
      '& h2': {
        fontSize: pxToEm(15),
        lineHeight: pxToEm(20),
        marginBottom: pxToEm(6)
      }
    },
    '& .sentiment-counter': {
      textAlign: 'center',
      '& p': {
        color: themeV2.color.base.gray.dark,
        fontSize: pxToEm(15),
        fontWeight: 'bold',
        lineHeight: pxToEm(20),
        marginBottom: pxToEm(16)
      }
    },
    '& .sentiment-emojis': {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      textAlign: 'center',
      '& .emoji': {
        width: pxToEm(65),
        margin: replacePXinStringWithEM('0px 10px 20px'),
        '& .emoji-graphic': {
          width: '100%',
          marginBottom: pxToEm(4),
          '& .emojiicon': {
            maxHeight: '42px',
            display: 'inline-block',
          },
        },
        '&.overview': {
          '& .emoji-graphic': {
            '& .emojiicon': {
              maxHeight: '30px',
            },
          },
        },
        '& .emoji-count': {
          fontSize: pxToEm(14), //'13px',
          marginTop: pxToEm(10),
          marginBottom: pxToEm(10),
        },
        '& .emoji-name': {
          color: themeV2.color.base.gray.secondary,
          fontSize: pxToEm(12),
          textTransform: 'capitalize',
        },
        '&:not(.overview):hover': {
          color: 'red !important',
          cursor: 'pointer',
        }
      }
    }
  }
};
